<div>
	@if (showForm()) {
		<nz-tabs>
			<nz-tab [nzTitle]="edit() ? 'Edit Course' : 'Add Course'">
				<app-setup-wizard-course-form
					[loading]="loading()"
					[edit]="edit()?.after || edit()?.before || null"
					(onClear)="onFormClear()"
					(onSubmit)="onFormSubmit($event)"
				></app-setup-wizard-course-form>
			</nz-tab>
			@if (edit(); as edit) {
				@let courseUuid = (edit.after || edit.before)?.course_uuid;

				@if (courseUuid) {
					<nz-tab nzTitle="Add Unit">
						<app-setup-wizard-unit-form
							[courseUuid]="courseUuid"
							[loading]="loading()"
							(onClear)="onFormClear()"
							(onSubmit)="onUnitFormSubmit($event)"
						></app-setup-wizard-unit-form>
					</nz-tab>
					<nz-tab nzTitle="Add Section">
						<app-setup-wizard-section-form
							[courseUuid]="courseUuid"
							[loading]="loading()"
							(onClear)="onFormClear()"
							(onSubmit)="onSectionFormSubmit($event)"
						></app-setup-wizard-section-form>
					</nz-tab>
				} @else {
					<nz-tab nzTitle="Add Units &amp; Sections">
						<p>
							You must first submit the job to save this new course before you can add sections &amp;
							locations to it.
						</p>
					</nz-tab>
				}
			}
		</nz-tabs>
	} @else {
		<div class="top-buttons">
			<button nz-button nzType="primary" (click)="onAdd()" class="add-button">Add</button>

			<div>
				<app-setup-wizard-upload-csv-button></app-setup-wizard-upload-csv-button>

				<app-setup-wizard-download-csv-button
					[key]="SetupWizardPayloadObjectKeys.courses"
				></app-setup-wizard-download-csv-button>
			</div>
		</div>
	}
</div>
<div>
	<app-setup-wizard-courses-table
		[selectedRow]="edit()"
		(onEdit)="onEdit($event)"
		(onToggleDisable)="onToggleDisable($event)"
		(onRemove)="onRemove($event)"
		(onReset)="onReset($event)"
	></app-setup-wizard-courses-table>
</div>
